import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DesktopShareContent from '../DesktopShareContent';
import { getDeviationResourceType, getTranslatedDeviationTitle } from '../../../DeviationViews/_helpers';
import { getDeviationShareCodes } from '../../helpers';
import s from './DesktopShareModal.scss';
const DesktopShareModal = ({ deviation , onRequestClose  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(Modal, {
        heading: t('share.shareOnSocial'),
        onRequestClose: onRequestClose,
        contentClassName: s['root'],
        ignoreClickOutside: true,
        isOpen: true
    }, /*#__PURE__*/ React.createElement(DesktopShareContent, _extends({
        title: getTranslatedDeviationTitle(deviation, t),
        biData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, getDeviationShareCodes(deviation))));
};
DesktopShareModal.displayName = 'DesktopShareModal';
export default DesktopShareModal;
